import { Artist } from '../types/artist';
import { Setlist } from '../types/setlist';
import { PredictedSetlist } from '../types/predictedSetlist';

export async function searchArtists(artistName: string, limit: number = 20): Promise<{ artists: Artist[]; total: number; query: string }> {
  const params = new URLSearchParams({ artistName, limit: String(limit) });
  const res = await fetch(`/api/v1/artists/search?${params}`, { credentials: 'include' });
  if (!res.ok) {
    if (res.status === 400) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || 'Invalid search query');
    }
    if (res.status === 429) throw new Error('Too many requests — please wait a moment and try again.');
    if (res.status >= 500) throw new Error('Search service is temporarily unavailable. Please try again shortly.');
    throw new Error('Failed to search artists');
  }
  return res.json();
}

export async function getArtistSetlists(mbid: string, limit: number = 5): Promise<{ setlists: Setlist[]; total: number }> {
  const params = new URLSearchParams({ limit: String(limit) });
  const res = await fetch(`/api/v1/artists/${encodeURIComponent(mbid)}/setlists?${params}`, { credentials: 'include' });
  if (!res.ok) {
    if (res.status === 404) return { setlists: [], total: 0 };
    if (res.status === 429) throw new Error('Too many requests — please wait a moment and try again.');
    if (res.status >= 500) throw new Error('Setlist service is temporarily unavailable. Please try again shortly.');
    throw new Error('Failed to fetch setlists');
  }
  return res.json();
}

export async function getPredictedSetlist(mbid: string, limit: number = 5, excludeIds: string[] = []): Promise<PredictedSetlist> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (excludeIds.length > 0) {
    params.set('excludeIds', excludeIds.join(','));
  }
  const res = await fetch(`/api/v1/artists/${encodeURIComponent(mbid)}/predicted-setlist?${params}`, { credentials: 'include' });
  if (!res.ok) {
    if (res.status === 404) throw new Error('No setlist data found for this artist.');
    if (res.status === 429) throw new Error('Too many requests — please wait a moment and try again.');
    if (res.status >= 500) throw new Error('Prediction service is temporarily unavailable. Please try again shortly.');
    throw new Error('Failed to fetch predicted setlist');
  }
  return res.json();
}
